module.exports = {
  name: 'GatewayBar',
  props: ['userId', 'enableAuth', 'enableSearch'],
  data: function() {
    return {
      valid: false,
      authCode: null,
      userAuth: null,
      authCodeRules: [
        v => !!v || this.$t('gateway.code_is_required'),
        v => (v && v.match(/^[0-9A-Za-z]{6}$/)) ? true : this.$t('gateway.code_is_no_valid')
      ],
      userMac: [],
      searchWord: null,
      compact: true
    }
  },
  methods: {
    async submit() {
      if(this.$refs.form.validate()) {
        let code = this.authCode.toUpperCase();
        let uid = this.userId;
        this.$refs.form.reset();
        this.popup(this.$t('gateway.bind_gateway_with', {
          code: code
        }));
        let ref = this.$db.ref('userAuth').child(uid);
        await ref.remove();
        await ref.set(code);
        ref.on('value', snapshot => {
          let val = snapshot.val();
          if(val) {
            if(val === 'invalid') {
              this.popup(this.$t('gateway.invalid_code', {
                code: this.userAuth
              }));
              snapshot.ref.remove();
              snapshot.ref.off();
            } else if(val.length == 12) {
              this.popup(this.$t('gateway.get_gateway_ready', {
                mac: val
              }));
              snapshot.ref.remove();
              snapshot.ref.off();
            } else {
              this.userAuth = val;
            }
          }
        });
        setTimeout(() => ref.off(), 5000);
      }
    },
    popup(val) {
      this.$emit('popup', val);
    }
  },
  watch: {
    compact(val) {
      this.$emit('compact', val);
    },
    searchWord(val) {
      this.$emit('search', val);
    }
  },
  template: `
<v-toolbar flat color="transparent">
  <v-form v-model="valid" ref="form" lazy-validation v-on:submit.prevent="submit" class="mr-2">
    <v-text-field mask="NNNNNN" :disabled="!enableAuth" v-model="authCode" :rules="authCodeRules" prepend-icon="vpn_key" append-icon="send" @click:append="submit" :placeholder="$t('gateway.auth_code')" hide-details single-line></v-text-field>
  </v-form>
  <v-spacer></v-spacer>
  <v-form class="mr-4 hidden-xs-only">
    <v-text-field :disabled="!enableSearch" v-model="searchWord" prepend-icon="search" :placeholder="$t('gateway.search')" hide-details single-line clearable></v-text-field>
  </v-form>
  <v-tooltip bottom>
    <v-btn flat @click="compact=true" slot="activator" icon>
      <v-icon>view_list</v-icon>
    </v-btn>
    <span>{{ $t('gateway.compact_view' )}}</span>
  </v-tooltip>
  <v-tooltip bottom>
    <v-btn flat @click="compact=false" slot="activator" icon>
      <v-icon>view_module</v-icon>
    </v-btn>
    <span>{{ $t('gateway.expanded_view' )}}</span>
  </v-tooltip>
</v-toolbar>
  `
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/luffanet-web-components/GatewayBar.js
// module id = YGsn
// module chunks = 0